// support for templates/_partials/page-content.html

import Player from '@vimeo/player';
import Flickity from 'flickity';
import throttle from '../modules/throttle';
import style from "../modules/style";
import {positionTooltip} from "../modules/tooltips";

const handleBlockquoteLists = function (el) {

  // Matches `@include mq(medium)`
  let matches = window.matchMedia('(min-width: 769px)').matches

  let flickity = new Flickity(el, {
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    selectedAttraction: 0.08,
    friction: 0.5,
    cellAlign: matches ? 'center' : 'left',
  })

}

const PageContentRoute = () => {
    const animationElements = Array.from(document.querySelectorAll(".animation-wrapper"));
    const blockquoteListElements = Array.from(document.querySelectorAll('[data-blockquote-slideshow]'))
    const blocks = [];

    const initBlockquoteList = () => {
      blockquoteListElements.forEach(handleBlockquoteLists)      
    }

    initBlockquoteList()

    window.addEventListener('resize', throttle(initBlockquoteList, 30))

    animationElements.forEach(element => {
        const iframe = element.querySelector("iframe");
        const player = new Player(iframe);
        const playReplayBtn = element.querySelector(".play-replay");
        const stoppedClass = "stopped";
        const playingClass = "playing";

        playReplayBtn.title = "Play";

        /**
        * Use a custom cue point just near the end so we can pause
        * and avoid Vimeo’s required end screen and use a still
        * frame instead.
        */
        player.getDuration().then((duration) => {
            player.addCuePoint(duration - 1, {
                nearEnd: "nearEnd"
            });
        });

        player.on("cuepoint", (event) => {
            if (typeof event.data.nearEnd !== "undefined") {
                player.pause();
            }
        });

        player.on("pause", (event) => {
            element.classList.remove(playingClass);
            element.classList.add(stoppedClass);
            playReplayBtn.title = "Replay";
        });

        /**
         * We should never get to `ended`!
         */
        player.on("ended", () => {
            player.pause();
        });

        player.on("play", () => {
            element.classList.remove(stoppedClass);
            element.classList.add(playingClass);
            playReplayBtn.title = "Pause";
        });

        playReplayBtn.addEventListener("click", () => {
            player.getPaused().then(function(paused) {
                if (paused) {
                    player.setCurrentTime(0);
                    player.play();
                } else {
                    player.pause();
                }
            });
        })

        blocks.push({
            element: element,
            player: player,
            hasPlayed: false
        });
    });

    if (animationElements.length > 0) {
        window.addEventListener("scroll", (event) => {
            blocks.forEach((block) => {
                if (elementAtCenter(block.element)) {
                    if (!block.hasPlayed) {
                        block.hasPlayed = true;
                        block.player.getPaused().then(function(paused) {
                            if (paused) {
                                block.player.setCurrentTime(0);
                                block.player.play();
                            }
                        });
                    }
                }
            });
        });
    }

    /**
     * Returns `true` if the element has scrolled past the vertical center of
     * the scrolled window.
     * 
     * @param {*} element 
     * @returns boolean
     */
    const elementAtCenter = (element) => {
        // require *some* movement
        if (window.scrollY === 0) {
            return false;
        }

        // element’s vertical distance from the top of the scrolled viewport
        const elementTop = element.getBoundingClientRect().top;
        const visibleWindowHeight = window.innerHeight || document.documentElement.clientHeight;

        return elementTop <= (visibleWindowHeight / 2);
    };

    // Peekable links!
    const PEEKABLE_URI_PATTERNS = [
        {
            pattern: new RegExp(`${window.location.origin}/glossary/(.+)`),
            apiPath: `${window.location.origin}/api/glossary/$1`,
            tag: 'glossary',
        },
        // ...
    ];

    const $peekableRegions = document.querySelectorAll('[data-peekables]');

    $peekableRegions.forEach(function($r) {
        const $anchors = $r.querySelectorAll('a');

        $anchors
            .forEach(function($a) {
                const transformer = PEEKABLE_URI_PATTERNS.find(function (p) {
                    return p.pattern.test($a.href);
                });

                if (!transformer) {
                    console.debug(`Ignoring anchor in peekable region: ${$a.href}`);
                    return;
                }

                // Flag the anchor itself with state and style hooks:
                $a.dataset.isPeekable = true;
                $a.classList.add('peekable', `peekable--${transformer.tag}`);

                $a.addEventListener('mouseenter', function(e) {
                    if ($a.dataset.isLoaded || $a.dataset.isLoading) {
                        return;
                    }

                    // Ok, here we go!
                    $a.dataset.isLoading = true;

                    fetch($a.href.replace(transformer.pattern, transformer.apiPath))
                        .then(function(r) {
                            return r.json();
                        })
                        .then(function(json) {
                            return createTooltip(json.summaryPlain);
                        })
                        .then(function($tooltip) {
                            // Tooltips must be mounted inside a non-statically positioned element:
                            style($a, {
                                position: 'relative',
                            });

                            $a.appendChild($tooltip);

                            // The child `tooltip_box` element is the one we actually need to position:
                            const $box = $tooltip.querySelector('.tooltip__box');
                            $a.addEventListener('mousemove', function(e) {
                                positionTooltip(e, $box);
                            });
                        })
                        .finally(function() {
                            $a.dataset.isLoaded = true;
                            $a.dataset.isLoading = false;
                        });
                });
            });
    });

    function createTooltip(content) {
        // Create the content:
        const $tooltipContent = document.createElement('div');
        $tooltipContent.classList.add('tooltip__content');
        $tooltipContent.innerHTML = content;

        // Add it to the “box”:
        const $tooltipBox = document.createElement('div');
        $tooltipBox.classList.add('tooltip__box');
        $tooltipBox.appendChild($tooltipContent);

        // Build the container:
        const $tooltip = document.createElement('div');
        $tooltip.classList.add('tooltip');
        $tooltip.appendChild($tooltipBox);

        return $tooltip;
    }
};

export default PageContentRoute;
